import { ThemeType, CssType } from '../../theme/jss-types';

const SideDrawerStyles = (theme: ThemeType) : CssType => ({
  drawer: {
    zIndex: 1000,
    '& .ant-drawer-header': {
      margin: '24px 16px 0px !important',
      padding: '0 0 24px 0 !important',
    },
  },
  moduleName: {
    marginLeft: '6px',
    color: '#262626',
    fontSize: '16px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  vendorDetails: {
    marginLeft: '25px',
    marginTop: '10px',
  },
  menu: {
    '& .ant-select:not(.ant-select-customize-input) .ant-select-selector, .ant-input': {
      borderRadius: 16,
      border: '1px solid #999999',
    },
  },
});

export default SideDrawerStyles;
